export const PENDING_CHIPS_HELP_TEXT =
  'os chips podem estar em transferência ou em vendas pendentes'
